module.exports = __webpack_public_path__ + "static/media/mask.37cab4fb.png";